import type { MultiLang } from '../config';
import FlickrBadge from '../custom/blocks/FlickrBadge';
import styles from './RightColumn.module.css';

interface Props {
    lang: MultiLang;
}

const RightColumn = (_props: Props) => {
    return (
        <td className={styles.rightColumn}>
            <div className={styles.rightBlock}>
                <h2 className={styles.rightBlockTitle}>Eye Photos</h2>
                <div className={styles.rightBlockContent}>
                    <FlickrBadge tags="eye,pupil" />
                </div>
            </div>
        </td>
    );
};

export default RightColumn;
